module.exports = __webpack_public_path__ + "img/descarga.bbf5074a.svg";